module.exports = __webpack_public_path__ + "img/x14.82a98319.jpg";